import { RemirrorManager } from 'remirror';
import {
  DocExtension,
  ParagraphExtension,
  TextExtension,
} from 'remirror/extensions';
import { ReplacementExtension } from './ReplacementExtension';
import { TempoMark } from './TempoMark';
import { LoudnessMark } from './LoudnessMark';
import { PitchMark } from './PitchMark';
import PauseMark from './PauseMark';
import { CueCommandsExtension } from './CueCommandsExtension';
import PauseCueCommandsExtension from './PauseCueCommandsExtension';
import { ClearMarksExtension } from './ClearMarksExtension';

/*
 * Headless Remirror manager for replacement transforms without a mounted editor.
 *
 * Uses the same extension set as the live editor so the schema — and therefore
 * parse/serialize behaviour — is identical. Omissions vs the live editor:
 *   - HistoryExtension     (no undo stack needed)
 *   - PlaceholderExtension (visual only)
 *   - CountExtension       (fires character-limit warnings)
 *   - ReplacementExtension isEnabled: false  (suppresses onStateUpdate)
 */
export default class HeadlessReplacementManager {
  readonly manager: RemirrorManager<
    ReturnType<typeof createExtensions>[number]
  >;

  readonly ext: ReplacementExtension;

  constructor() {
    this.manager = RemirrorManager.create(createExtensions) as RemirrorManager<
      ReturnType<typeof createExtensions>[number]
    >;
    this.ext = this.manager.getExtension(ReplacementExtension);
  }
}

const createExtensions = () => [
  new DocExtension({ content: 'block+' }),
  new TextExtension(),
  new ParagraphExtension(),
  new ReplacementExtension({ className: '', isEnabled: false }),
  new TempoMark({ className: '' }),
  new LoudnessMark({ className: '' }),
  new PitchMark({ className: '' }),
  new PauseMark({ className: '' }),
  new CueCommandsExtension(),
  new PauseCueCommandsExtension(),
  new ClearMarksExtension(),
];
